import React from "react";
import EventIcon from "../../../../../images/payment/card-icon.svg";
import CreditIcon from "../../../../../images/payment/bank-ach-icon.svg";
import InvoiceIcon from "../../../../../images/payment/invoice-payment-icon.svg"; 
import { BillingMethodType, EditBillingMethodType } from "../enums";
import { FlexContainer, IconButton } from "@mindmemobile/mm-shared-global";

type IProps = {
  selectedMethod:
    | keyof typeof BillingMethodType
    | keyof typeof EditBillingMethodType;
  onChange: (value: string) => void;
  isEdit?: boolean;
  showLabel?: boolean;
  className?: string;
};

export const billingMethods = [
  {
    icon: CreditIcon,
    label: "Charge Payment",
    value: Object.keys(BillingMethodType).find(
      (key) =>
        BillingMethodType[key as keyof typeof BillingMethodType] ===
        BillingMethodType.ChargePayment
    ),
    className: "",
  },
  {
    icon: InvoiceIcon,
    label: "Request Payment",
    value: Object.keys(BillingMethodType).find(
      (key) =>
        BillingMethodType[key as keyof typeof BillingMethodType] ===
        BillingMethodType.RequestPayment
    ),
    className: "invoice-icon",
  },
];

export const editBillingMethods = [
  {
    icon: EventIcon,
    label: "Use Existing",
    value: Object.keys(EditBillingMethodType).find(
      (key) =>
        EditBillingMethodType[key as keyof typeof EditBillingMethodType] ===
        EditBillingMethodType.UseExistingPayment
    ),
  },
  {
    icon: EventIcon,
    label: "Create New",
    value: Object.keys(EditBillingMethodType).find(
      (key) =>
        EditBillingMethodType[key as keyof typeof EditBillingMethodType] ===
        EditBillingMethodType.CreateNewPayment
    ),
  },
];

const BillingMethods: React.FC<IProps> = ({
  selectedMethod,
  onChange,
  isEdit,
  className,
}) => {
  const handleInputChange = (value: string) => {
    if (
      BillingMethodType[value as keyof typeof BillingMethodType] ===
      BillingMethodType.RequestPayment
    ) {
      return;
    }
    onChange(value);
  };

  const billingMethodss = !isEdit ? billingMethods : editBillingMethods;

  return (
    <div>
      <FlexContainer
        alignItems="center"
        spacing={20}
        className="subs-billing-btns"
      >
        {billingMethodss.map((method) => (
          <IconButton
            key={method.label}
            className={`blue-btn-green-hovered ${selectedMethod === method.value ? "active" : ""}`}
            onClick={() => method.value && handleInputChange(method.value)}
          >
            <img src={method.icon} alt="" className={className} />
            <span>{method.label}</span>
          </IconButton>
        ))}
      </FlexContainer>
    </div>
  );
};

export default BillingMethods;
